var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.1167,
    y: 1.16666,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#825DFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2086 6.40826C11.0311 6.39023 10.8502 6.38095 10.6667 6.38095C8.27217 6.38095 6.33105 7.96112 6.33105 9.91036C6.33105 11.8596 8.27217 13.4398 10.6667 13.4398C11.0409 13.4398 11.4041 13.4012 11.7506 13.3286L13.3764 14.9524V12.6835C14.1063 12.1899 14.6929 11.4483 14.9025 10.6667M14.9025 8.25595C14.9025 8.99562 14.3029 9.59524 13.5632 9.59524C12.8235 9.59524 12.2239 8.99562 12.2239 8.25595C12.2239 7.51628 12.8235 6.91667 13.5632 6.91667C14.3029 6.91667 14.9025 7.51628 14.9025 8.25595Z",
    stroke: "#825DFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionDefault);
export default __webpack_public_path__ + "static/media/question-default.7586a3347a2447133e804ff42f00afe0.svg";
export { ForwardRef as ReactComponent };